export const buildDefaultChartData = (): Chart.ChartData & {
  legend: { name: string; short: string }[];
} => {
  return {
    labels: [],
    datasets: [],
    legend: [],
  };
};
